window.jQuery = window.$ = require('jquery');
let processInclude = require('./util');
$(document).ready(function () {
    highlightCurrentCategory();
    processInclude(require('./fc-menu'));
});

function highlightCurrentCategory() {
  var currentPath = window.location.pathname;
  console.log('=== DEBUG START ===');
  console.log('Current path:', currentPath);
  
  var $menuNav = $('.fc-navbar-nav');
  var categoriesJson = $menuNav.attr('data-categories');
  
  if (!categoriesJson) {
    console.error('No categories data');
    return;
  }
  
  try {
    var categories = JSON.parse(categoriesJson);

    $('.fc-nav-link').removeClass('font-weight-bold');

    categories.forEach(function(cat, index) {
      console.log(`  ${index + 1}. ${cat.name} (${cat.id}) -> ${cat.url}`);
    });

    var foundCategoryUrl = null;
    var searchPath = currentPath.toLowerCase().replace(/\/$/, '');

    for (var i = 0; i < categories.length; i++) {
      var category = categories[i];
      var categoryUrl = category.url ? category.url.toLowerCase().replace(/\/$/, '') : '';

      if (categoryUrl === searchPath) {
        foundCategoryUrl = category.url;
        break;
      }

      var baseCategoryUrl = categoryUrl.replace(/-2$/, '');
      if (searchPath.startsWith(baseCategoryUrl + '/')) {
        foundCategoryUrl = category.url;
        break;
      }

      if (category.subCategories && category.subCategories.length > 0) {
        if (searchInSubcategories(category.subCategories, searchPath)) {
          foundCategoryUrl = category.url;
          break;
        }
      }
    }
    
    if (foundCategoryUrl) {
      $('.fc-nav-link').each(function() {
        var $link = $(this);
        var linkUrl = $link.attr('href');

        if (linkUrl) {
          try {
            var linkObj = new URL(linkUrl, window.location.origin); 
            var linkPath = linkObj.pathname.toLowerCase();
            $link.removeClass('font-weight-bold');

            if (foundCategoryUrl === linkPath) {
              $link.addClass('font-weight-bold');
              
              var $parentMegamenu = $link.closest('.fc-megamenu');
              if ($parentMegamenu.length) {
                $parentMegamenu.find('.fc-nav-link').first().addClass('font-weight-bold');
              }
            }
          } catch (e) {
            console.error('Error parsing URL:', linkUrl, e);
          }
        }
      });
    } else {
      console.log('No category found to highlight');
    }
      
  } catch (e) {
    console.error('Error:', e);
  }
}

function searchInSubcategories(subCategories, searchPath) {
  for (var i = 0; i < subCategories.length; i++) {
    var subCat = subCategories[i];
    var subCatUrl = subCat.url ? subCat.url.toLowerCase().replace(/\/$/, '') : '';

    if (subCatUrl === searchPath) {
      return true;
    }

    if (searchPath.startsWith(subCatUrl + '/')) {
      return true;
    }

    if (subCat.subCategories && subCat.subCategories.length > 0) {
      if (searchInSubcategories(subCat.subCategories, searchPath)) {
        return true;
      }
    }
  }
  return false;
}